// extracted by mini-css-extract-plugin
export default {"tooltip":"NR-z","arrow":"OR-z"};